import { Link } from 'react-router-dom';
import Metadata from '../components/Metadata';

export default function NotFound() {
  return (
    <div className="bg-wine-950 text-sand-50 min-h-[70vh] flex items-center justify-center py-24 font-sans">
      <Metadata title="Page Not Found - La Fable by La Fontaine" description="The page you are looking for does not exist. Go back to the front page of La Fable by La Fontaine." />

      <div className="mx-auto max-w-md px-6 text-center space-y-8">
        <div className="flex justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-none bg-zinc-950 text-sand-300 border border-white/10 shadow-md">
            <i className="fa-solid fa-wine-glass-crack text-3xl" />
          </div>
        </div>
        
        <div className="space-y-2">
          <span className="font-sans text-xs tracking-[0.2em] uppercase text-sand-300 block font-light">
            ERROR 404
          </span>
          <h1 className="font-serif text-3xl sm:text-4xl font-normal text-sand-50 tracking-wide">
            Page Not Found
          </h1>
        </div>
        
        <p className="font-sans text-sm font-light text-sand-200/80 leading-relaxed">
          It looks like the glass is empty, or you've wandered onto a page that doesn't exist in our wine cellar.
        </p>

        <div className="pt-2">
          <Link
            to="/"
            className="px-8 py-3.5 border border-sand-300 bg-sand-300 text-wine-950 text-xs uppercase tracking-[0.2em] hover:bg-transparent hover:text-sand-300 transition-all duration-300 inline-flex items-center justify-center gap-2 group"
          >
            Go to Front Page
            <i className="fa-solid fa-arrow-right text-[10px] transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </div>
  );
}
